import React, { useEffect, useRef } from "react";
// Using our custom SearchBox for tracking instead of Quintype's
import { SearchBox } from "../../../molecules/SearchBox";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";

import { OPEN_SEARCHBAR } from "../../../store/actions";
import { SvgIconHandler } from "../../../atoms/SvgIconHandler";
import { Button } from "../../../atoms";

import "./navbar-search.m.css";

function DrawForm({ children }) {
  return [
    <label htmlFor="searchForm" key="1">
      {children}
    </label>,
    <Button key="2" customStyleName="bg-brand-primary">
      Search
    </Button>,
  ];
}

const NavbarSearch = () => {
  const dispatch = useDispatch();
  const allStates = useSelector((state) => state);
  const qtState = get(allStates, ["qt"], {});
  const storyHeaderInView = get(allStates, "storyHeaderInView", true);
  const pageType = qtState.pageType;
  const isSearchBarOpen = useSelector((state) => get(state, ["isSearchBarOpen"], false));
  const config = get(qtState, ["config"], "");
  const fromLocation = get(qtState, ["data", "story"], {});

  const toggleSearchForm = () => {
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: !isSearchBarOpen,
    });
    document.getElementById("searchForm").focus();
  };

  const closeSearchBar = () => {
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          closeSearchBar();
        }
      }
      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  const formStyle = {
    transform: isSearchBarOpen ? "translate(0, 0)" : "",
  };

  return (
    <div styleName="search" ref={wrapperRef}>
      <button aria-label="search-button" styleName="search__btn" onClick={() => toggleSearchForm()}>
        {/* <SvgIconHandler
          styleName="header-search"
          type="search"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          className="search"
        /> */}
      </button>
      <div styleName="search-form-container">
        <div
          styleName={`search-form ${isSearchBarOpen ? "active" : ""} ${
            pageType === "user-login" ? "marginRight" : ""
          } ${storyHeaderInView ? "" : "stickyRight"}`}
          style={formStyle}
        >
          <SearchBox
            styleName="search-box"
            template={DrawForm}
            inputId="searchForm"
            inputClassName="search__form-input"
            onSubmitHandler={() => closeSearchBar()}
            onEscape={() => closeSearchBar()}
            placeholder="Search"
            searchType="navbar"
            pageType={pageType}
            config={config}
            fromLocation={fromLocation}
          />
        </div>
      </div>
    </div>
  );
};

export { NavbarSearch };
